const stepStartKey = (documentKey: string | null, step: string) =>
  `step_start_${documentKey}_${step}`

export function setStepStartTime(documentKey: string | null, step: string) {
  sessionStorage.setItem(stepStartKey(documentKey, step), String(Date.now()))
}

export function getStepStartTime(documentKey: string | null, step: string): number | null {
  const value = sessionStorage.getItem(stepStartKey(documentKey, step))
  return value ? Number(value) : null
}

export function clearStepStartTime(documentKey: string | null, step: string) {
  sessionStorage.removeItem(stepStartKey(documentKey, step))
}

const LAST_COMPLETION_TIME_KEY = 'last_completion_time'

export function setLastCompletionTime() {
  localStorage.setItem(LAST_COMPLETION_TIME_KEY, String(Date.now()))
}

export function getLastCompletionTime(): number | null {
  const value = localStorage.getItem(LAST_COMPLETION_TIME_KEY)
  return value ? Number(value) : null
}

export function getSecSinceLastCompletion(): number | null {
  const lastCompletionTime = getLastCompletionTime()
  return lastCompletionTime ? (Date.now() - lastCompletionTime) / 1000 : null
}
